export const LOGIN_BEGIN = 'login_begin';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_ERROR = 'login_error';
export const LOGIN_RESET = 'login_reset';